module.exports = __webpack_public_path__ + "static/img/pro2.3c23975b.png";